import { render } from "./FormGroup.vue?vue&type=template&id=5dbaef46&ts=true"
import script from "./FormGroup.vue?vue&type=script&lang=ts"
export * from "./FormGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__